export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://internal.kixlab.org:7888';

export const API_URLS = {
  GENERATE_SUGGESTIONS: `${API_BASE_URL}/openai/generate_suggestions`,
  FIND_LOGICAL_FLAWS: `${API_BASE_URL}/openai/find_logical_flaws_all`,
  VALIDATE_FRAME: `${API_BASE_URL}/openai/validate_frame`,
  VALIDATE_FRAME_MINI: `${API_BASE_URL}/openai/validate_frame_mini`,
  COMMENT_ROOTS: `${API_BASE_URL}/comments/roots`,
  FETCH_COMMENT: (commentId: number) => `${API_BASE_URL}/comments/${commentId}`,
  SEND_COMMENTS: `${API_BASE_URL}/comments/`, // New route added
};